var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB0053E46F632Dee91C4Fefe3Fd4D7775(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "420px",
    height: "420px",
    viewBox: "0 0 420 420",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Selviytyminen-tarppo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selviytyminen-tarppo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ribbon-center",
    transform: "translate(60.000000, 165.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 28
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 62,
    y: 16,
    width: 174,
    height: 70
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    strokeLinecap: "square",
    points: "62 60 0 60 15.888356 30 0 0 62 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(236.000000, 0.000000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    transform: "translate(31.000000, 30.000000) scale(-1, 1) translate(-31.000000, -30.000000) ",
    points: "62 60 0 60 15.888356 30 0 0 62 0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M210,419 C94.5722857,419 1,325.427714 1,210 C1,94.5722857 94.5722857,1 210,1 C325.427714,1 419,94.5722857 419,210 C419,325.427714 325.427714,419 210,419 Z",
    id: "Fill-17",
    fill: "#5E0F75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.665399,71.5 L223.665239,95.0142222 L283.994796,155.343685 L229.210164,210.128036 L283.994796,264.912574 L223.414093,325.492996 L223.414093,348.5 L196.329648,348.5 L196.329648,325.236924 L136.005204,264.912574 L190.789648,210.128036 L136.005204,155.343685 L196.580795,94.768 L196.580955,71.5 L223.665399,71.5 Z M210.058999,229.2792 L210,229.338481 L209.940813,229.2792 L174.308392,264.912574 L210,300.604182 L245.691608,264.912574 L210.058999,229.2792 Z M210,119.652078 L174.308392,155.343685 L209.940813,190.976871 L210,190.917778 L210.058999,190.976871 L245.691608,155.343685 L210,119.652078 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB0053E46F632Dee91C4Fefe3Fd4D7775);
export default __webpack_public_path__ + "static/media/b0053e46f632dee91c4fefe3fd4d7775.d824f03abeb6ec457c5d68acbb17c383.svg";
export { ForwardRef as ReactComponent };